import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from '@/store';
import vuetify from './plugins/vuetify';
// @ts-ignore
import VueSplide from '@splidejs/vue-splide';
import '@splidejs/splide/dist/css/themes/splide-skyblue.min.css';
// @ts-ignore
import VueTheMask from 'vue-the-mask';
// @ts-ignore
import Vuelidate from 'vuelidate';
import VueCurrencyInput from 'vue-currency-input';
import { getSendLogParams, removeNodes } from '@/utils/common';

import Toast, { TYPE } from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import { TOKENS } from '@/utils/mask';
import { sendLog } from '@/api/logger';
import '@/api/axiosInterceptors';

import {$t} from './store/i18n';
Vue.prototype.$t = $t;   // теперь во всех шаблонах доступно {{ $t('key') }}

// Глобальная настройка всплывающих уведомлений
Vue.use(Toast, {
  position: 'top-center',
  timeout: 2000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.3,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  closeButton: 'button',
  toastDefaults: {
    [TYPE.ERROR]: {
      icon: {
        iconChildren: 'cancel_circle',
        iconTag: 'i',
      },
    },
    [TYPE.SUCCESS]: {
      icon: {
        iconChildren: 'check_circle',
        iconTag: 'i',
      },
    },
  },
  rtl: false,
});

Vue.config.productionTip = false;
Vue.use(Vuelidate);
Vue.use(VueSplide);
Vue.use(VueTheMask);
Vue.use(VueCurrencyInput, {
  globalOptions: {
    currency: null,
    distractionFree: false,
  },
});

window.addEventListener('load', () => {
  removeNodes(['#main-loader', '#main-loader-styles']);
});

// window.addEventListener('unhandledrejection', async function (evt) {
//   await sendLog({
//     ...getSendLogParams,
//     error: evt.reason.stack ?? evt.reason.message,
//   });
// });

Vue.config.errorHandler = async function (err) {
  await sendLog({
    ...getSendLogParams,
    error: err.stack ?? err.message,
  });

  throw err;
};

Vue.config.warnHandler = async function (msg, vm, trace) {
  await sendLog({
    ...getSendLogParams(),
    error: trace,
  });
  console.warn(trace);
};

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');

Vue.mixin({
  data() {
    return {
      firstLetterUppercaseMask: {
        mask: 'F' + 'T'.repeat(59),
        tokens: TOKENS,
      },
      KPP: {
        mask: '9999KK999',
        tokens: TOKENS,
      },
    };
  },
});
